// test77
(77 && 0);
